package com.trevorwiebe.timesheet.core.data

import com.trevorwiebe.timesheet.core.data.dto.GeocodeResponseDto
import com.trevorwiebe.timesheet.core.domain.GeocodePoint
import com.trevorwiebe.timesheet.core.domain.GeocodingConfig
import com.trevorwiebe.timesheet.core.domain.GeocodingRepository
import com.trevorwiebe.timesheet.core.domain.TSResult
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.plugins.ServerResponseException
import io.ktor.client.request.get
import io.ktor.client.request.parameter
import io.ktor.util.network.UnresolvedAddressException

class GeocodingRepositoryImpl(
    private val httpClient: HttpClient,
    private val config: GeocodingConfig
) : GeocodingRepository {

    override suspend fun geocode(address: String): TSResult {
        if (address.isBlank()) return TSResult(error = "Enter an address first")

        val response = try {
            httpClient.get(urlString = "https://maps.googleapis.com/maps/api/geocode/json") {
                parameter("address", address)
                parameter("key", config.apiKey)
            }
        } catch (e: UnresolvedAddressException) {
            return TSResult(error = "No network connection")
        } catch (e: ServerResponseException) {
            return TSResult(error = "Geocoding server error")
        }

        if (response.status.value !in 200..299) {
            return TSResult(error = "Geocoding failed (${response.status.value})")
        }

        val body = response.body<GeocodeResponseDto>()
        return when (body.status) {
            "OK" -> {
                val result = body.results.firstOrNull()
                    ?: return TSResult(error = "Address not found")
                TSResult(
                    data = GeocodePoint(
                        latitude = result.geometry.location.lat,
                        longitude = result.geometry.location.lng,
                        formattedAddress = result.formattedAddress
                    )
                )
            }
            "ZERO_RESULTS" -> TSResult(error = "Address not found")
            else -> TSResult(error = body.errorMessage ?: "Geocoding failed (${body.status})")
        }
    }
}
